export const ICONS = {
    devices: 'ea77',
    laptop: 'ea78',
    mobile_alt: 'ea79',
    mobile: 'ea7a',
    monitor: 'ea7b',
    tablet: 'ea7c',
    group_alt: 'ea7d',
    group: 'ea7e',
    id_card: 'ea7f',
    user_check: 'ea80',
    user_circle: 'ea81',
    user_close: 'ea82',
    user_heart: 'ea83',
    user_minus: 'ea84',
    user_pin: 'ea85',
    user_plus: 'ea86',
    user_square: 'ea87',
    user_voice: 'ea88',
    user: 'ea89',
    bar_bottom: 'ea8a',
    bar_left: 'ea8b',
    bar_right: 'ea8c',
    bar_top: 'ea8d',
    barcode: 'ea8e',
    code: 'ea8f',
    cylinder: 'ea90',
    data: 'ea91',
    filter_o: 'ea92',
    filter_off_o: 'ea93',
    filter_off: 'ea94',
    filter: 'ea95',
    lock: 'ea96',
    qr_code_1: 'ea97',
    qr_code: 'ea98',
    terminal: 'ea99',
    transfer: 'ea9a',
    window_check: 'ea9b',
    window_close: 'ea9c',
    window_code_block: 'ea9d',
    window_sidebar: 'ea9e',
    window_terminal: 'ea9f',
    window: 'eaa0',
    dot_01_xs: 'eaa1',
    dot_02_s: 'eaa2',
    dot_03_m: 'eaa3',
    dot_04_l: 'eaa4',
    dot_05_xl: 'eaa5',
    dummy_icon_lg_fill: 'eaa6',
    dummy_icon_lg_line: 'eaa7',
    dummy_icon_md_fill: 'eaa8',
    dummy_icon_md_line: 'eaa9',
    dummy_icon_sm_fill: 'eaaa',
    dummy_icon_sm_line: 'eaab',
    line_l: 'eaac',
    line_m: 'eaad',
    line_s: 'eaae',
    line_sx: 'eaaf',
    line_xl: 'eab0',
    notification_active: 'e901',
    notification_deactivated: 'e902',
    notification_dot: 'e903',
    notification_minus: 'e904',
    notification_o_dot: 'e905',
    notification_o_minus: 'e906',
    notification_o_plus: 'e907',
    notification_o: 'e908',
    notification_plus: 'e909',
    notification: 'e90a',
    close_big: 'e90b',
    close_small: 'e90c',
    hamburger: 'e90d',
    menu_alt_01: 'e90e',
    menu_alt_02: 'e90f',
    menu_alt_03: 'e910',
    menu_alt_04: 'e911',
    menu_alt_05: 'e912',
    menu_duo_alt: 'e913',
    menu_duo: 'e914',
    more_horizontal: 'e915',
    more_vertical: 'e916',
    airplay: 'e917',
    cast: 'e918',
    fast_forward: 'e919',
    fast_rewind: 'e91a',
    pause_circle_filled: 'e91b',
    pause_circle_o: 'e91c',
    play_arrow: 'e91d',
    play_circle_filled: 'e91e',
    play_circle_o: 'e91f',
    repeat: 'e920',
    shuffle: 'e921',
    skip_next: 'e922',
    skip_previous: 'e923',
    building: 'e924',
    home_alt_check: 'e925',
    home_alt_minus: 'e926',
    home_alt_plus: 'e927',
    home_alt_x: 'e928',
    home_check: 'e929',
    home_fill: 'e92a',
    home_heart_1: 'e92b',
    home_heart: 'e92c',
    home_minus: 'e92d',
    home_outline: 'e92e',
    home_plus: 'e92f',
    home_x: 'e930',
    dashboard_02: 'e931',
    dashboard: 'e932',
    grid_big_round: 'e933',
    grid_big: 'e934',
    grid_horizontal_round: 'e935',
    grid_horizontal: 'e936',
    grid_round: 'e937',
    grid_small_round: 'e938',
    grid_small: 'e939',
    grid_vertical_round: 'e93a',
    grid_vertical: 'e93b',
    grid: 'e93c',
    cloud_check: 'e93d',
    cloud_close: 'e93e',
    cloud_down: 'e93f',
    cloud_off: 'e940',
    cloud_outline: 'e941',
    cloud_up: 'e942',
    cloud: 'e943',
    file_archive: 'e944',
    file_blank_fill: 'e945',
    file_blank_o: 'e946',
    file_css: 'e947',
    file_find: 'e948',
    file_html: 'e949',
    file_image: 'e94a',
    file_jpg: 'e94b',
    file_js: 'e94c',
    file_minus: 'e94d',
    file_new: 'e94e',
    file_pdf: 'e94f',
    file_png: 'e950',
    file_svg: 'e951',
    folder_minus: 'e952',
    folder_open: 'e953',
    folder_plus: 'e954',
    folder: 'e955',
    note: 'e956',
    receipt: 'e957',
    black_lives_matter: 'e958',
    bulb: 'e959',
    coffee_togo: 'e95a',
    color: 'e95b',
    cookie: 'e95c',
    cupcake: 'e95d',
    happy: 'e95e',
    moon: 'e95f',
    sad: 'e960',
    sun: 'e961',
    tennis_match_alt: 'e962',
    tennis_match: 'e963',
    tennis: 'e964',
    thunder: 'e965',
    bar_chart_alt: 'e966',
    bar_chart_circle: 'e967',
    bar_chart_horizontal: 'e968',
    bar_chart_square: 'e969',
    bar_chart: 'e96a',
    doughnut_chart: 'e96b',
    line_chart_down: 'e96c',
    line_chart_up: 'e96d',
    pie_chart_25: 'e96e',
    pie_chart_50: 'e96f',
    pie_chart_75: 'e970',
    pie_chart_outline_25: 'e971',
    pie_chart_outline: 'e972',
    trending_down: 'e973',
    trending_up: 'e974',
    add_column: 'e975',
    add_row: 'e976',
    add_to_queue: 'e977',
    bold: 'e978',
    combine_cells: 'e979',
    copy: 'e97a',
    delete_column: 'e97b',
    delete_row: 'e97c',
    double_quotes_l: 'e97d',
    double_quotes_r: 'e97e',
    edit_o: 'e97f',
    edit: 'e980',
    heading_h1: 'e981',
    heading_h2: 'e982',
    heading_h3: 'e983',
    heading_h4: 'e984',
    heading_h5: 'e985',
    heading_h6: 'e986',
    heading: 'e987',
    hide: 'e988',
    italic: 'e989',
    line_break: 'e98a',
    list_check: 'e98b',
    list_checklist_alt: 'e98c',
    list_checklist: 'e98d',
    list_minus: 'e98e',
    list_ol: 'e98f',
    list_plus: 'e990',
    list_ul: 'e991',
    mention: 'e992',
    minus_circle_o: 'e993',
    minus_circle: 'e994',
    minus_square: 'e995',
    minus: 'e996',
    move_horizontal: 'e997',
    move_vertical: 'e998',
    move: 'e999',
    off_close: 'e99a',
    off_outline_close: 'e99b',
    paragraph: 'e99c',
    plus_circle_o: 'e99d',
    plus_circle: 'e99e',
    plus_square: 'e99f',
    plus: 'e9a0',
    redo: 'e9a1',
    ruler: 'e9a2',
    search_2: 'e9a3',
    search_small_minus: 'e9a4',
    search_small_plus: 'e9a5',
    search_small: 'e9a6',
    search: 'e9a7',
    select_multiple: 'e9a8',
    show: 'e9a9',
    single_quotes_l: 'e9aa',
    single_quotes_r: 'e9ab',
    strikethrough: 'e9ac',
    table_add: 'e9ad',
    table_delete: 'e9ae',
    table: 'e9af',
    text_align_center: 'e9b0',
    text_align_justify: 'e9b1',
    text_align_left: 'e9b2',
    text_align_right: 'e9b3',
    underline: 'e9b4',
    undo: 'e9b5',
    chat_alt: 'e9b6',
    chat: 'e9b7',
    message_check: 'e9b8',
    message_circle: 'e9b9',
    message_close: 'e9ba',
    message_minus: 'e9bb',
    message_plus_alt: 'e9bc',
    message_plus: 'e9bd',
    message_round: 'e9be',
    message_writing: 'e9bf',
    message: 'e9c0',
    calendar_calendar: 'e9c1',
    calendar_check: 'e9c2',
    calendar_edit: 'e9c3',
    calendar_event: 'e9c4',
    calendar_minus: 'e9c5',
    calendar_plus: 'e9c6',
    calendar_week: 'e9c7',
    calendar_x_1: 'e9c8',
    calendar_x: 'e9c9',
    calendar: 'e9ca',
    error_o: 'e9cb',
    error: 'e9cc',
    info_circle_o: 'e9cd',
    info_circle: 'e9ce',
    info_square_o: 'e9cf',
    info_square: 'e9d0',
    warning_o: 'e9d1',
    warning: 'e9d2',
    caret_down: 'e9d3',
    caret_left: 'e9d4',
    caret_right: 'e9d5',
    caret_up: 'e9d6',
    chevron_big_down: 'e9d7',
    chevron_big_left: 'e9d8',
    chevron_big_right: 'e9d9',
    chevron_big_up: 'e9da',
    chevron_down: 'e9db',
    chevron_duo_down: 'e9dc',
    chevron_duo_left: 'e9dd',
    chevron_duo_right: 'e9de',
    chevron_duo_up: 'e9df',
    chevron_left: 'e9e0',
    chevron_right: 'e9e1',
    chevron_up: 'e9e2',
    circle_chevron_down: 'e9e3',
    circle_chevron_left: 'e9e4',
    circle_chevron_right: 'e9e5',
    circle_chevron_up: 'e9e6',
    circle_down: 'e9e7',
    circle_left: 'e9e8',
    circle_right: 'e9e9',
    circle_up: 'e9ea',
    expand: 'e9eb',
    first_page: 'e9ec',
    last_page: 'e9ed',
    long_bottom_down: 'e9ee',
    long_bottom_up: 'e9ef',
    long_down: 'e9f0',
    long_left: 'e9f1',
    long_right: 'e9f2',
    long_up_left: 'e9f3',
    long_up_right: 'e9f4',
    long_up: 'e9f5',
    short_down: 'e9f6',
    short_left: 'e9f7',
    short_right: 'e9f8',
    short_up: 'e9f9',
    shrink: 'e9fa',
    small_long_down: 'e9fb',
    small_long_left: 'e9fc',
    small_long_right: 'e9fd',
    small_long_up: 'e9fe',
    sub_left: 'e9ff',
    sub_right: 'ea00',
    thin_big_down: 'ea01',
    thin_big_left: 'ea02',
    thin_big_right: 'ea03',
    thin_big_up: 'ea04',
    thin_long_02_down: 'ea05',
    thin_long_02_left: 'ea06',
    thin_long_02_right: 'ea07',
    thin_long_02_up: 'ea08',
    thin_long_down: 'ea09',
    thin_long_left: 'ea0a',
    thin_long_right: 'ea0b',
    thin_long_up: 'ea0c',
    unfold_less: 'ea0d',
    unfold_more: 'ea0e',
    alarm_add: 'ea0f',
    alarm: 'ea10',
    cash_2_o: 'ea11',
    cash_2: 'ea12',
    cash: 'ea13',
    check_all_big: 'ea14',
    check_all: 'ea15',
    check_big: 'ea16',
    check_bold: 'ea17',
    check: 'ea18',
    checkbox_checked: 'ea19',
    checkbox_square: 'ea1a',
    checkbox: 'ea1b',
    circle_check_o: 'ea1c',
    circle_check: 'ea1d',
    clock: 'ea1e',
    command: 'ea1f',
    confused: 'ea20',
    credit_card_alt: 'ea21',
    credit_card: 'ea22',
    download_done: 'ea23',
    download: 'ea24',
    exit: 'ea25',
    external_link: 'ea26',
    flag_fill: 'ea27',
    flag_o: 'ea28',
    heart_fill: 'ea29',
    heart_o: 'ea2a',
    help_circle_o: 'ea2b',
    help_circle: 'ea2c',
    help_questionmark: 'ea2d',
    image_alt: 'ea2e',
    image: 'ea2f',
    label: 'ea30',
    layers_alt: 'ea31',
    layers: 'ea32',
    link_02: 'ea33',
    link: 'ea34',
    loading: 'ea35',
    location_o: 'ea36',
    location: 'ea37',
    log_out: 'ea38',
    mail_open: 'ea39',
    mail: 'ea3a',
    map: 'ea3b',
    path: 'ea3c',
    phone_o: 'ea3d',
    phone: 'ea3e',
    radio_filled: 'ea3f',
    radio: 'ea40',
    refresh_02: 'ea41',
    refresh: 'ea42',
    safe: 'ea43',
    settings_filled: 'ea44',
    settings_future: 'ea45',
    settings: 'ea46',
    share_o: 'ea47',
    share: 'ea48',
    shoping_bag_o: 'ea49',
    slider_01: 'ea4a',
    slider_02: 'ea4b',
    slider_03: 'ea4c',
    stopwatch: 'ea4d',
    tag_o: 'ea4e',
    tag: 'ea4f',
    trash_empty: 'ea50',
    trash_full: 'ea51',
    unlink: 'ea52',
    addi: 'ea53',
    apple: 'ea54',
    coolicons: 'ea55',
    css3: 'ea56',
    discord: 'ea57',
    dribbble: 'ea58',
    drive: 'ea59',
    dropbox: 'ea5a',
    facebook: 'ea5b',
    figma: 'ea5c',
    github: 'ea5d',
    google: 'ea5e',
    html5: 'ea5f',
    instagram: 'ea60',
    invision: 'ea61',
    javascript: 'ea62',
    linkedin: 'ea63',
    linkpath: 'ea64',
    messenger: 'ea65',
    patreon: 'ea66',
    paypal: 'ea67',
    pix: 'ea68',
    play_store: 'ea69',
    reddit: 'ea6a',
    sketch: 'ea6b',
    slack: 'ea6c',
    snapchat: 'ea6d',
    soundcloud: 'ea6e',
    spectrum: 'ea6f',
    spotify: 'ea70',
    stack_overflow: 'ea71',
    trello: 'ea72',
    twitch: 'ea73',
    twitter: 'ea74',
    unsplash: 'ea75',
    youtube: 'ea76',
    whast_app_c: 'e900',
    arrow_down_circle: 'eab1',
};
//# sourceMappingURL=icons.js.map